export default "__VITE_ASSET__799s$YWL__"